import React from 'react';
import Col from 'js/components/grid/column';
import Row from 'js/components/grid/row';
import Panel from 'js/components/panel/panel';
import Box from 'js/components/box/box';
import Text from 'js/components/text/text';
import logo from 'media/images/logos/logo.svg';
import styles from './login.module.scss';

function EnvironmentOffline() {
    return (
        <div className={styles.container} style={{ justifyContent: 'center' }}>
            <Panel bordered>
                <Box padding={['large', 'large']}>
                    <Row>
                        <Col span="auto">
                            <img className={styles.logo} src={logo} alt="4D" />
                        </Col>
                        <Col>
                            <Text weight="bolder" size="largest">
                                <h1>4D</h1>
                            </Text>
                            <Box margin={['smaller', 0, 0]}>
                                <Text color={['gray', 'dark']}>
                                    <p>
                                        Contextual intelligence and brand
                                        suitability.
                                    </p>
                                </Text>
                            </Box>
                        </Col>
                    </Row>
                    <Row>
                        <Box margin={['large', 0, 0]}>
                            <Text weight="bolder" size="larger">
                                Something’s resting behind the scenes — back in
                                action soon!
                            </Text>
                        </Box>
                    </Row>
                </Box>
            </Panel>
        </div>
    );
}

export default EnvironmentOffline;
